const computeBackendEndpoint = (backendBaseUrl, endpoint) => {
  return `${backendBaseUrl}${endpoint}`;
};

export { computeBackendEndpoint };
